<div style="padding: 30px">

  <div style="margin-bottom: 20px" i18n="@@search-tree-search-via-tree">
    Search via 'synthetic tree', i.e. based on field values instead of physical storage.<br/><br/>
    <b>Note that this tree will only work if the following metadata fields are all present:
    Country, Place, Department, Year, Month, Balzac code, Voucher code.</b>
  </div>

  <p-tree
    selectionMode="single"
    [value]="nodes()"
    [loading]="loading()"
    (onNodeExpand)="nodeExpand($event)"
    (onNodeCollapse)="nodeCollapse($event)">
    <ng-template let-node pTemplate="pdf-result">
        <span>{{node.data.type}}: {{node.data.voucher_code}}</span>
        <span style="margin-left: 10px; font-weight: bold" pTooltip="">
          <a [routerLink]="['/viewer/' + node.data.uuid]">{{node.data.filename}}</a>
        </span>
    </ng-template>
  </p-tree>

</div>
